import { useState, useEffect } from 'react';

/**
 * Detects if the app is running as an installed PWA on iOS.
 * Used to hide payment/subscription UI for Apple App Store compliance (Guideline 3.1.1).
 */
export function useIsIOSApp() {
  const [isIOSApp, setIsIOSApp] = useState(false);

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isStandalone = window.navigator.standalone === true ||
      window.matchMedia('(display-mode: standalone)').matches;
    setIsIOSApp(isIOS && isStandalone);
  }, []);

  return isIOSApp;
}
